var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { ConnectionsIcon } from '../elements/connections-icon';
import { ContentNode } from './content-node';
import { useLang } from '../../hooks/use-lang';
import { get, groupBy, map } from 'lodash';
import { useTheme } from '../../hooks/use-theme';
import { OutlineEntityDotLink } from './outline-entity-dot-link';
import AnimateHeight from 'react-animate-height';
import { useInViewEffect } from '../../hooks/use-in-view-effect';
var cls = classNames('entity-connections-list');
export var EntityConnectionsListDefaultProps = {
  items: [],
  keyOrder: [],
  marginSize: 56,
  marginSpaceUnits: 4,
  title: 'Connections'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n  "], ["\n    display: flex;\n    align-items: flex-start;\n  "])))
});
var HeaderBodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n\n  "], ["\n    ", "\n\n  "])), function (_a) {
    var _spaceUnits = _a._spaceUnits;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-left: ", "; \n    "], ["\n      margin-left: ", "; \n    "])), theme.UNIT(_spaceUnits));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n    ", ";\n    ", "\n  "], ["\n    flex-shrink: 0;\n    ", ";\n    ", "\n  "])), theme.FILL('text-mid'), function (_a) {
    var _size = _a._size,
        rotation = _a.rotation;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      transition: transform 0.5s;\n      transform: rotate(", "deg);\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      transition: transform 0.5s;\n      transform: rotate(", "deg);\n      width: ", "px;\n      height: ", "px;\n    "])), rotation, _size, _size);
  })
});
var TitleStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-weight: 500;\n    margin: 0;\n    margin-bottom: ", ";\n    font-size: ", ";\n    ", "\n  "], ["\n    font-weight: 500;\n    margin: 0;\n    margin-bottom: ", ";\n    font-size: ", ";\n    ", "\n  "])), theme.UNIT(1), theme.FONT_SIZE(18), function (_a) {
    var _shift = _a._shift;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      margin-top: ", "px; \n    "], ["\n      margin-top: ", "px; \n    "])), _shift);
  })
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('text'), theme.UNIT(3))
});
var BodyStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SectionStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding-bottom: ", ";\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n  "], ["\n    padding-bottom: ", ";\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n  "])), theme.UNIT(4))
});
var GroupNameStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    font-weight: 300;\n    text-transform: uppercase;\n    border-top: 1px solid ", ";\n    font-size: ", ";\n    color: ", ";\n    padding-top: ", ";\n    ", "\n  "], ["\n    font-weight: 300;\n    text-transform: uppercase;\n    border-top: 1px solid ", ";\n    font-size: ", ";\n    color: ", ";\n    padding-top: ", ";\n    ", "\n  "])), theme.COLOR('line-mid'), theme.FONT_SIZE(14), theme.COLOR('text-mid'), theme.UNIT(4), function (_a) {
    var _indent = _a._indent;
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      margin-left: ", "px;\n    "], ["\n      margin-left: ", "px;\n    "])), _indent);
  })
});
var ItemsStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    list-style: none;\n    padding: 0;\n    position: relative;\n    margin: 0;\n  "], ["\n    list-style: none;\n    padding: 0;\n    position: relative;\n    margin: 0;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    ", "\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    margin-bottom: ", ";\n    ", "\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "])), theme.UNIT(2), function (_a) {
    var _indent = _a._indent;
    return css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      margin-left: ", "px;\n    "], ["\n      margin-left: ", "px;\n    "])), _indent);
  })
});
var OutlineEntityLinkStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    justify-self: flex-start;\n  "], ["\n    justify-self: flex-start;\n  "])))
});
var LineStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    width: 2px;\n    position: absolute;\n    ", ";\n\n    ", "\n  "], ["\n    width: 2px;\n    position: absolute;\n    ", ";\n\n    ", "\n  "])), theme.V_DOT_BG('line'), function (_a) {
    var _shift = _a._shift;
    return _shift && css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      left: ", "px; \n      top: ", "px;\n      height: calc(100% - ", "px);\n    "], ["\n      left: ", "px; \n      top: ", "px;\n      height: calc(100% - ", "px);\n    "])), (_shift - 2) / 2, _shift, _shift);
  })
}); // -------- Components -------->

var My = {
  Container: styled.article(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Line: styled.span.attrs(cls.attr('line'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), LineStyles),
  Header: styled.header.attrs(cls.attr('header'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Icon: styled(ConnectionsIcon)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  HeaderBody: styled.div.attrs(cls.attr('header-body'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), HeaderBodyStyles),
  Title: styled.h1.attrs(cls.attr('title'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: styled(ContentNode)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Body: styled.main.attrs(cls.attr('body'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Group: styled.section.attrs(cls.attr('group'))(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  GroupName: styled.h2.attrs(cls.attr('group-name'))(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), GroupNameStyles),
  Items: styled.ul.attrs(cls.attr('items'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled.li.attrs(cls.attr('item'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  OutlineLink: styled(OutlineEntityDotLink)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), OutlineEntityLinkStyles)
};
export var EntityConnectionsList = function EntityConnectionsList(props) {
  var className = props.className,
      items = props.items,
      children = props.children,
      title = props.title,
      marginSize = props.marginSize,
      marginSpaceUnits = props.marginSpaceUnits,
      description = props.description;
  var hasDescription = description && description.text;
  var hasHeader = !!title || hasDescription;

  var _a = __read(useState(0), 2),
      height = _a[0],
      setHeight = _a[1];

  var _b = __read(useState(0), 2),
      rotation = _b[0],
      setRotation = _b[1];

  var th = useTheme();
  var t = useLang();
  var gridUnit = get(th, 'grid.unit', 4);
  var marginSpace = marginSpaceUnits * gridUnit;
  var itemsByGroup = groupBy(items, 'groupName');
  var ref = useInViewEffect(function () {
    setHeight("auto");
    setRotation(180);
  });
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, React.createElement(My.Line, {
    _shift: hasHeader && marginSize
  }), hasHeader && React.createElement(My.Header, {
    className: cls.sub('header')
  }, React.createElement(My.Icon, {
    rotation: rotation,
    _size: marginSize
  }), React.createElement(My.HeaderBody, {
    className: cls.sub('header-body'),
    _spaceUnits: marginSpaceUnits
  }, React.createElement(My.Title, {
    _shift: marginSize / 4
  }, t(title)), React.createElement(My.Description, {
    entity: description
  }))), React.createElement(AnimateHeight, {
    duration: 500,
    height: height
  }, React.createElement(My.Body, {
    className: cls.sub('body')
  }, map(itemsByGroup, function (groupItems, groupName) {
    var groupNameIndent = marginSize + marginSpace;
    return React.createElement(My.Group, {
      className: cls.sub('group'),
      key: groupName
    }, groupName && React.createElement(My.GroupName, {
      className: cls.sub('group-name'),
      _indent: groupNameIndent
    }, groupName), React.createElement(My.Items, null, groupItems.map(function (item) {
      var dotLinkProps = __assign(__assign({}, item.dotLinkProps || {}), {
        dotProps: __assign({
          size: 28
        }, item.dotLinkProps && item.dotLinkProps.dotProps)
      });

      var itemIndent = (marginSize - dotLinkProps.dotProps.size) / 2;
      dotLinkProps.spaceUnits = itemIndent / gridUnit + marginSpaceUnits;
      return React.createElement(My.Item, {
        className: cls.sub('item'),
        _indent: itemIndent,
        key: groupName + "-" + item.entity.id
      }, React.createElement(My.OutlineLink, __assign({
        className: cls.sub('outline-link'),
        entity: item.entity
      }, dotLinkProps)));
    })));
  }))), children);
};
EntityConnectionsList.defaultProps = EntityConnectionsListDefaultProps;
EntityConnectionsList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32;